import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { client } from '../api';
import type { PriorAuthReviewsResponse, PriorAuthReviewSummary } from '../api';
import PageContainer from '../components/PageContainer';
import PriorAuthReviewsTable from '../components/priorAuthReviews/PriorAuthReviewsTable';
import { Outlet } from 'react-router-dom';
import { priorAuthReviewsQueryKey } from '../queries';
import { formatStandardDateLocaleString } from 'shared-utils/utils/formatDate';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';
import { PageLoadError } from 'design-system/src/components/PageLoadError/PageLoadError';

const PriorAuthReviewsTablePage: React.FC = () => {
  const { data, isLoading, error } = useQuery<PriorAuthReviewsResponse>({
    queryKey: priorAuthReviewsQueryKey(),
    queryFn: () =>
      client.get('/prior-auth-reviews').then((res) => {
        res.data.prior_auth_reviews = res.data.prior_auth_reviews.map((item: PriorAuthReviewSummary) => ({
          ...item,
          // We format dates here instead of in TasksTable so that the global search function applies to the formatted data
          created_at: formatStandardDateLocaleString(item.created_at),
          prescription_recieved_at: formatStandardDateLocaleString(item.prescription_recieved_at),
        }));
        return res.data;
      }),
  });

  let body;
  if (isLoading) {
    body = <LoadingSpinner />;
  } else if (error) {
    body = <PageLoadError />;
  } else if (data) {
    body = <PriorAuthReviewsTable data={data.prior_auth_reviews} />;
  }

  return (
    <>
      <PageContainer
        title="Prior Auth Reviews"
        subtitle="These prior authorizations require review from your team before submission."
      >
        {body}
      </PageContainer>
      <Outlet />
    </>
  );
};

export default PriorAuthReviewsTablePage;
